import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBuildAssetUrl } from '~/common/hooks/useBuildAssetUrl';

export const useNavigateToAsset = () => {
  const navigate = useNavigate();
  const { buildAssetUrl } = useBuildAssetUrl();

  const navigateToAsset = useCallback(
    (assetId: string) => {
      if (window.getSelection()?.toString().trim()) return;
      navigate(buildAssetUrl(assetId));
    },
    [navigate, buildAssetUrl]
  );

  return { navigateToAsset };
};
